import React, { useState, useEffect } from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  OutlinedInput,
  Checkbox,
  ListItemText
} from '@mui/material';
import historiaService from '../../services/historiaService';

const FiltroCitasPorEtapa = ({ programaId, onChange, value = [] }) => {
  const [etapas, setEtapas] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchEtapas = async () => {
      if (!programaId) {
        setEtapas([]);
        return;
      }

      try {
        setLoading(true);
        const data = await historiaService.getEtapasByPrograma(programaId);
        setEtapas(data || []);
      } catch (err) {
        console.error("Error al cargar etapas:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchEtapas();
  }, [programaId]);

  const handleChange = (event) => {
    const {
      target: { value: newValue },
    } = event;
    
    // Si es un arreglo, pasar el valor
    if (Array.isArray(newValue)) {
      onChange(newValue);
    } else {
      // Si seleccionamos "Todas", devolver un arreglo vacío
      onChange(newValue === 'todas' ? [] : [newValue]);
    }
  };

  // Encontrar nombre de etapa por ID
  const getEtapaNombre = (id) => {
    const etapa = etapas.find(e => e.id === id);
    return etapa ? etapa.nombre : '';
  };

  return (
    <FormControl sx={{ minWidth: 200 }} size="small">
      <InputLabel id="filtro-etapas-label">Etapa</InputLabel>
      <Select
        labelId="filtro-etapas-label"
        id="filtro-etapas"
        multiple
        value={value}
        onChange={handleChange}
        input={<OutlinedInput label="Etapa" />}
        renderValue={(selected) => (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            {selected.length === 0 ? (
              <Chip label="Todas" size="small" />
            ) : (
              selected.map((etapaId) => (
                <Chip 
                  key={etapaId} 
                  label={getEtapaNombre(etapaId)} 
                  size="small" 
                />
              ))
            )}
          </Box>
        )}
        disabled={loading || etapas.length === 0}
      >
        <MenuItem value="todas">
          <Checkbox checked={value.length === 0} />
          <ListItemText primary="Todas las etapas" />
        </MenuItem>
        
        {etapas.map((etapa) => (
          <MenuItem key={etapa.id} value={etapa.id}>
            <Checkbox checked={value.indexOf(etapa.id) > -1} />
            <ListItemText primary={etapa.nombre} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default FiltroCitasPorEtapa;